export const YEARS_GET = 'YEARS_GET';
export const YEAR_ADD = 'YEAR_ADD';
export const YEAR_EDIT = 'YEAR_EDIT';
export const YEAR_GET = 'YEAR_GET';
export const YEAR_DELETE = 'YEAR_DELETE';
